var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ProductForm',{attrs:{"product":_vm.$store.state.products.product,"onSubmit":_vm.submit}})}
var staticRenderFns = []

export { render, staticRenderFns }